import Component from '@cell/cell-core/component/component';
import './product-card.scss';

class ProductCard extends Component {
  constructor() {
    super();

    this.productId = this.parsedDataset.productId;
    this.productTitle = this.parsedDataset.productTitle;
    this.productVendor = this.parsedDataset.productVendor;
    this.productCategory = this.parsedDataset.productCategory;
    this.variantName = this.parsedDataset.variantName;
    this.price = this.parsedDataset.price;
    this.currentCollectionId = this.parsedDataset.currentCollectionId;
    this.currentCollectionTitle = this.parsedDataset.currentCollectionTitle;

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.on('click', this.handleClick);
  }

  handleClick() {
    // The Select Item Event should only be sent when the user clicks on the product card on the
    // collection page. `this.currentCollectionTitle` will only be set on collection pages.
    if (!this.currentCollectionTitle) return;

    this.sendSelectItemEvent();
  }

  sendSelectItemEvent() {
    const data = {
      currency: window.Shopify.currency.active,
      item_list_id: this.currentCollectionId.toString(),
      item_list_name: this.currentCollectionTitle,
      items: [
        {
          item_id: this.parsedDataset.productId.toString(),
          item_name: this.parsedDataset.productTitle,
          item_brand: this.parsedDataset.productVendor,
          item_category: this.parsedDataset.productCategory,
          item_variant: this.variantName,
          price: this.parsedDataset.price,
          quantity: 1,
        },
      ],
    };

    window.Shopify.analytics.publish('custom_select_item', data);
  }
}

customElements.define('product-card', ProductCard);
